module.exports = __webpack_public_path__ + "static/media/CTLI_12-444w.0e08ced3.webp";